import { useScope } from '@nyos/core-framework'

export default function PostLoginScopeOverlay() {
  const { activeScope, availableScopes, setActiveScope } = useScope()

  if (availableScopes.length <= 1 || activeScope !== null) {
    return null
  }

  const canGroup = availableScopes.every((s) => s.operatingEntityName)

  const handleSelect = (scope: any) => {
    setActiveScope(scope)
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950/95 p-4">
      <div className="w-full max-w-md rounded-lg shadow-xl p-6 bg-slate-900 border border-slate-700">
        <h2 className="text-lg font-semibold mb-2 text-white">Select a Yard</h2>
        <p className="text-sm text-slate-400 mb-4">
          You have access to multiple facilities. Choose which yard to work in.
        </p>

        <div className="space-y-4">
          {canGroup
            ? groupByEntity(availableScopes).map(([entityName, scopes]) => (
                <div key={entityName}>
                  <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">
                    {entityName}
                  </h3>
                  <div className="space-y-2">
                    {scopes.map((scope) => (
                      <ScopeButton key={scope.facilityId} scope={scope} onSelect={handleSelect} />
                    ))}
                  </div>
                </div>
              ))
            : availableScopes.map((scope) => (
                <ScopeButton key={scope.facilityId} scope={scope} onSelect={handleSelect} />
              ))}
        </div>
      </div>
    </div>
  )
}

function groupByEntity(scopes: any[]): [string, any[]][] {
  const map: Record<string, any[]> = {}
  for (const s of scopes) {
    const key = s.operatingEntityName!
    if (!map[key]) map[key] = []
    map[key].push(s)
  }
  return Object.entries(map)
}

function ScopeButton({ scope, onSelect }: { scope: any; onSelect: (s: any) => void }) {
  return (
    <button
      onClick={() => onSelect(scope)}
      className="w-full text-left px-4 py-3 rounded-md border border-slate-700 bg-slate-800 hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors"
    >
      <div className="font-medium text-white">{scope.name || scope.facilityId}</div>
    </button>
  )
}
